module.exports = __webpack_public_path__ + "img/knsu_gallery5.8f7a18d4.jpg";